export default __webpack_public_path__ + "static/media/crypto-graph-favicon-green.04f90849.ico";